import settings from './settings';

export default {
  namespaced: true,
  modules: {
    settings
  },
  state: {
    data: []
  },
  getters: {
    columns(state) {
      return state.settings.data.map(i => {
        return {
          value: i,
          text: i
        };
      });
    }
  },

  actions: {
    load({ commit }, params) {
      if (!params) {
        const list = [];
        list.length = 40;
        list.fill({
          id: 1,
          name: 'Name #',
          avatar: '',
          'Actor type': 'user',
          actor: 'value',
          tags: 'action',
          editor: 'Pixel Admin'
        });
        commit(
          'set',
          list.map((i, n) => {
            return {
              ...i,
              id: i.id + n,
              name: `${i.name}${n}`,
              avatar: 'mdi-sticker-emoji'
            };
          })
        );
        commit(
          'settings/set',
          Object.keys(list[0]).filter(i => i !== 'avatar')
        );
      }
    }
  }
};
